import type { FunctionComponent } from 'react';

import DocsLink from '../../../generic/Link/DocsLink';
import type { JiraCustomField } from '../../../../../shared/jira';

import JiraCustomFields from './CustomFields';
import JiraSettingsSection from './JiraSettingsSection';

export type JiraSettingsCustomFieldsProps = {
  customFields: JiraCustomField[];
  onUpdateCustomFields: (fields: JiraCustomField[]) => void;
};

/**
 * Table for managing the Jira Custom Fields for this Jira instance.
 */
const JiraSettingsCustomFields: FunctionComponent<JiraSettingsCustomFieldsProps> = ({
  customFields,
  onUpdateCustomFields,
}) => (
  <JiraSettingsSection
    heading="Custom Fields"
    subHeading={
      <>
        Fields available during issue export. Note that FOSSA only supports simple text fields.
        {' '}
        <DocsLink to="atlassian-jira">
          Please read our docs for more info.
        </DocsLink>
      </>
    }
  >
    <JiraCustomFields
      customFields={customFields}
      isDisabled={false}
      onChange={onUpdateCustomFields}
    />
  </JiraSettingsSection>
);

export default JiraSettingsCustomFields;
